import EmblaCarousel from 'embla-carousel';

class ProductCarousel {
  constructor() {
    this.els = document.querySelectorAll('[js-product-carousel]');
    if (!this.els.length) {
      return;
    }

    this.els.forEach((el) => {
      this.init(el);
    });
  }

  async loadDynamicProducts(el) {
    const url = el.dataset.url;
    if (!url) {
      return;
    }

    try {
      const response = await fetch(url);
      if (!response.ok) {
        return;
      }

      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const sectionId = el.dataset.sectionId;
      const sourceEl = html.querySelector(`#ird-product-carousel-${sectionId}`);

      if (!sourceEl) {
        return;
      }

      el.innerHTML = sourceEl.innerHTML;
      el.removeAttribute('data-url');
    } catch (error) {
      // Recommendations are optional content.
    }
  }

  setCarouselControlsVisible(el, visible) {
    const controlsNode = el.querySelector('.ird-product-carousel__controls');
    if (controlsNode) {
      controlsNode.hidden = !visible;
    }
  }

  createSlider(el) {
    if (el.dataset.carouselInitialized === 'true') {
      return;
    }

    const viewportNode = el.querySelector('[js-product-carousel-slider]');
    const itemNodes = el.querySelectorAll('.ird-product-carousel__item');
    if (!viewportNode || itemNodes.length <= 1) {
      this.setCarouselControlsVisible(el, false);
      return;
    }

    const prevButtonNode = el.querySelector('[js-product-carousel-prev]');
    const nextButtonNode = el.querySelector('[js-product-carousel-next]');
    const emblaApi = EmblaCarousel(viewportNode, { loop: false, align: 'start' });

    prevButtonNode && prevButtonNode.addEventListener('click', () => emblaApi.scrollPrev(), false);
    nextButtonNode && nextButtonNode.addEventListener('click', () => emblaApi.scrollNext(), false);

    const updateButtons = () => {
      const canScrollPrev = emblaApi.canScrollPrev();
      const canScrollNext = emblaApi.canScrollNext();
      const needsScroll = canScrollPrev || canScrollNext;

      this.setCarouselControlsVisible(el, needsScroll);

      if (prevButtonNode) {
        if (!canScrollPrev) {
          prevButtonNode.setAttribute('disabled', 'disabled');
        } else {
          prevButtonNode.removeAttribute('disabled');
        }
      }

      if (nextButtonNode) {
        if (!canScrollNext) {
          nextButtonNode.setAttribute('disabled', 'disabled');
        } else {
          nextButtonNode.removeAttribute('disabled');
        }
      }
    }

    updateButtons();

    emblaApi.on('scroll', updateButtons);
    emblaApi.on('resize', updateButtons);

    el.dataset.carouselInitialized = 'true';
  }

  async init(el) {
    await this.loadDynamicProducts(el);
    this.createSlider(el);
  }
}

export default ProductCarousel;